<template>
    <div>

        <div class="title_block d-flex align-items-baseline">
            <h2 class="mb-4 mt-4">{{ model_person.first_name }} {{ model_person.last_name }}</h2>
        </div>

        <div class="person_category d-flex mb-4">
            <span>Category: {{ category.name }}</span>
            <div class="colors_block">
                <input class="color_radio" type="radio" :value="category.icon_base64">
            </div>
        </div>
        <div class="d-flex mb-5">Person ID: {{ model_person.uuid || model_person.person_uuid || model_person.id }}</div>
        <div class="main_person">

            <div class="d-flex justify-content-between">
                <div>
                    <button @click="movePerson(model_person.id)" class="btn btn-primary">MOVE</button>
                    <button @click="mergePerson(model_person.id)" class="btn btn-primary">MERGE</button>
                    <button @click="deletePerson(model_person.id)" class="btn btn-border">DELETE</button>
                    <button
                        type="button"
                        class="btn btn-border"
                        :disabled="!bestPublicImagePath"
                        :title="bestPublicImagePath ? 'Поиск по фото в Google Lens' : 'Нет публичного фото для поиска'"
                        @click="searchInGoogle"
                    >Найти в Google</button>
                    <button
                        type="button"
                        class="btn btn-primary"
                        :disabled="identifyBusy || !canIdentify"
                        title="Распознать знаменитость и заполнить поля"
                        @click="identifyCelebrity"
                    >{{ identifyBusy ? '…' : 'Распознать' }}</button>
                </div>
                <div>

                </div>
            </div>

            <div v-if="identifyOpen" class="celebrity-identify-modal">
                <div class="celebrity-identify-modal__bg" @click="closeIdentifyModal"></div>
                <div class="celebrity-identify-modal__body black_block">
                    <h4 class="form-block__title mb-3">{{ identifyModalTitle }}</h4>
                    <p v-if="identifyMessage" class="text-grey mb-3">{{ identifyMessage }}</p>
                    <div v-if="identifyCandidates.length > 1" class="mb-3">
                        <div class="black_block__title mb-2">Кандидаты</div>
                        <div class="d-flex flex-wrap">
                            <button
                                v-for="(c, idx) in identifyCandidates"
                                :key="'cand_' + idx"
                                type="button"
                                class="btn btn-sm me-2 mb-2"
                                :class="idx === identifySelectedIdx ? 'btn-primary' : 'btn-border'"
                                @click="selectIdentifyCandidate(idx)"
                            >{{ c.title || ((c.first_name || '') + ' ' + (c.last_name || '')) }}</button>
                        </div>
                    </div>
                    <div class="d-flex mb-2">
                        <div class="black_block__title">First name</div>
                        <input v-model="identifyDraft.first_name" type="text" class="form-control">
                    </div>
                    <div class="d-flex mb-2">
                        <div class="black_block__title">Last name</div>
                        <input v-model="identifyDraft.last_name" type="text" class="form-control">
                    </div>
                    <div class="d-flex mb-2">
                        <div class="black_block__title">Website</div>
                        <input v-model="identifyDraft.link" type="text" class="form-control">
                    </div>
                    <div class="d-flex mb-2">
                        <div class="black_block__title">Info</div>
                        <textarea v-model="identifyDraft.info" class="form-control" rows="6"></textarea>
                    </div>
                    <div v-if="identifyMode === 'manual'" class="mb-3">
                        <div class="black_block__title mb-2">Или вставьте имя из Google</div>
                        <div class="d-flex align-items-center">
                            <input
                                v-model="identifyPasteName"
                                type="text"
                                class="form-control"
                                placeholder="Например: Keanu Reeves"
                                @keyup.enter="enrichPastedName"
                            >
                            <button
                                type="button"
                                class="btn btn-border ms-2"
                                :disabled="identifyBusy || !identifyPasteName.trim()"
                                @click="enrichPastedName"
                            >Подставить</button>
                        </div>
                        <p class="mt-2 text-grey mb-0">
                            Wikipedia summary подтянется бесплатно; подтвердите Apply ниже.
                        </p>
                    </div>
                    <div class="mt-4 d-flex justify-content-between align-items-center">
                        <a
                            v-if="identifyGoogleUrl"
                            :href="identifyGoogleUrl"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="btn btn-link"
                        >Открыть Google Lens</a>
                        <span v-else></span>
                        <div>
                            <button type="button" class="btn btn-link" @click="closeIdentifyModal">Отмена</button>
                            <button
                                type="button"
                                class="btn btn-border"
                                :disabled="identifyBusy || !identifyDraft.first_name"
                                @click="applyIdentifyDraft"
                            >Apply</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="person-card-block mt-5">
                <div class="form-block">
                    <div class="black_block d-flex flex-column">
                        <h4 class="form-block__title mb-4">Photos</h4>
                        <div class="photo_block">
                            <div v-for="(photo, key) in personsFaces" :key="'face_' + photo.id" class="photo_block_item">                                
                                <input 
                                    v-model="photo.checked" 
                                    @change="changeItem" 
                                    :id="`t_${key}`" 
                                    type="checkbox" 
                                    class="custom_checkbox"
                                >
                                <label :for="`t_${key}`" class="photo_block_item" :style="`background-image: url(${photo.image && (photo.image.fullpath || ('/images/' + photo.image.path))})`"></label>
                            </div>
                        </div>
                        <p class="mt-4 text-grey">The face must be centered on the square photos. If this is not, please replace it.</p>
                        <div class="mt-4 d-flex justify-content-between align-items-center">
                            <a href="">Read how to take a photo</a>
                            <input @change="uploadImage" type="file" multiple id="uploadfile" class="d-none">
                            <label class="btn btn-border" for="uploadfile">BROWSE FILES</label>
                        </div>
                    </div>
                </div>
                <div class="form-block">
                    <div class="black_block d-flex flex-column">
                        <h4 class="form-block__title mb-4">Personal info</h4>
                        <div class="d-flex">
                            <div class="black_block__title">First name</div>
                            <input v-model="model_person.first_name" type="text" class="form-control">
                            <div @click="model_person.first_name = ''" class="btn-close"></div>
                        </div>
                        <hr>
                        <div class="d-flex">
                            <div class="black_block__title">Last name</div>
                            <input v-model="model_person.last_name" type="text" class="form-control">
                            <div @click="model_person.last_name = ''" class="btn-close"></div>
                        </div>
                        <hr>
                        <div class="d-flex">
                            <div class="black_block__title">Email</div>
                            <input v-model="model_person.email" type="email" class="form-control">
                            <div @click="model_person.email = ''" class="btn-close"></div>
                        </div>
                        <hr>
                        <div class="d-flex">
                            <div class="black_block__title">Website</div>
                            <input v-model="model_person.link" type="text" class="form-control">
                            <div @click="model_person.link = ''" class="btn-close"></div>
                        </div>
                        <hr>                        
                        <div class="d-flex">
                            <div class="black_block__title">Info</div>
                            <textarea v-model="model_person.info" class="form-control" rows="10"></textarea>
                            <div @click="model_person.info = ''" class="btn-close"></div>
                        </div>
                        <div class="mt-5 d-flex justify-content-end">
                            <button class="btn btn-link">CANСEL</button>
                            <button @click.prevent="updatePerson" class="btn btn-border">SAVE</button>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>

import {bus} from '../../bus';
import axios from 'axios';
import Dotscontrol from '../Dotscontrol';
import iconsort from "../iconsort";

export default {
    props: ['title_person', 'id', 'category'],
    data(){
        return{
            model_person: {
                first_name: '',
                last_name: '',
                vector: '',
                face_base64: '',
                email: '',
                website: '',
                info: '',
                id: '',
                uuid: ''
            },
            person_id: 1,
            sort_name: 'up',
            sort_person: 'up',
            model_all: false,
            listdelete: [],
            personsIds: [],
            images: [],
            sendFacesToSDKnum: 0, 
            sendFacesSDKlimit: 10,
            files: [],
            goodImagesFiles: [],
            badImages: [],
            badImagesB64: [],
            spoofWarnings: [],
            image_turn_id: '',
            hashes: [],
            identifyBusy: false,
            identifyOpen: false,
            identifyMode: 'manual',
            identifyMessage: '',
            identifyGoogleUrl: '',
            identifyPasteName: '',
            identifyCandidates: [],
            identifySelectedIdx: 0,
            identifyDraft: {
                first_name: '',
                last_name: '',
                info: '',
                link: '',
                title: ''
            }
        }
    },
    methods: {
        personUuid(){
            return (this.model_person && (this.model_person.uuid || this.model_person.person_uuid)) || '';
        },
        absolutePublicUrl(path){
            if (!path) return '';
            if (/^https?:\/\//i.test(path)) return path;
            const origin = (typeof window !== 'undefined' && window.location && window.location.origin)
                ? window.location.origin
                : '';
            return origin + (path.charAt(0) === '/' ? path : '/' + path);
        },
        warmAvatarCache(){
            const uuid = this.personUuid();
            if (!uuid || typeof Image === 'undefined') return;
            // Authenticated request warms public/images/avatar_cache/{uuid}.jpg for Google.
            const img = new Image();
            img.referrerPolicy = 'no-referrer';
            img.src = '/person-avatar/' + encodeURIComponent(uuid);
        },
        searchInGoogle(){
            const path = this.bestPublicImagePath;
            if (!path) {
                alert('Нет публичного URL фото (tip/avatar). Откройте страницу ещё раз или дождитесь загрузки фото.');
                return;
            }
            const abs = this.absolutePublicUrl(path);
            const lens = 'https://lens.google.com/uploadbyurl?url=' + encodeURIComponent(abs);
            window.open(lens, '_blank', 'noopener,noreferrer');
        },
        emptyIdentifyDraft(){
            return { first_name: '', last_name: '', info: '', link: '', title: '' };
        },
        applyCandidateToDraft(c){
            const cand = c || {};
            this.identifyDraft = {
                first_name: cand.first_name || '',
                last_name: cand.last_name || '',
                info: cand.info || '',
                link: cand.link || '',
                title: cand.title || ''
            };
        },
        selectIdentifyCandidate(idx){
            this.identifySelectedIdx = idx;
            this.applyCandidateToDraft(this.identifyCandidates[idx]);
        },
        openIdentifyModalFromPayload(data){
            const payload = data || {};
            this.identifyMode = payload.mode || 'manual';
            this.identifyMessage = payload.message || '';
            this.identifyGoogleUrl = payload.google_lens_url
                || payload.google_searchbyimage_url
                || '';
            this.identifyCandidates = Array.isArray(payload.candidates) ? payload.candidates : [];
            this.identifySelectedIdx = 0;
            this.identifyPasteName = '';
            if (this.identifyCandidates.length) {
                this.applyCandidateToDraft(this.identifyCandidates[0]);
            } else {
                this.identifyDraft = this.emptyIdentifyDraft();
            }
            this.identifyOpen = true;
            if (this.identifyMode === 'manual' && this.identifyGoogleUrl) {
                window.open(this.identifyGoogleUrl, '_blank', 'noopener,noreferrer');
            }
        },
        closeIdentifyModal(){
            this.identifyOpen = false;
            this.identifyBusy = false;
        },
        identifyCelebrity(){
            if (!this.canIdentify) {
                alert('Нет tip/avatar для распознавания.');
                return;
            }
            this.identifyBusy = true;
            this.warmAvatarCache();
            axios.post(`/persons/${this.id}/identify-celebrity`, {}, {
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                // 501 is expected when no API key — still open manual modal.
                validateStatus: function (status) {
                    return status >= 200 && status < 600;
                }
            }).then((response) => {
                const data = response.data || {};
                if (response.status === 404) {
                    alert((data && data.message) || 'Person not found');
                    return;
                }
                this.openIdentifyModalFromPayload(data);
            }).catch((error) => {
                console.log('identify-celebrity error', error);
                // Fallback: open Google + empty confirm modal.
                const path = this.bestPublicImagePath;
                const abs = path ? this.absolutePublicUrl(path) : '';
                this.openIdentifyModalFromPayload({
                    mode: 'manual',
                    message: 'Не удалось вызвать API. Откройте Google Lens и вставьте имя вручную.',
                    google_lens_url: abs
                        ? ('https://lens.google.com/uploadbyurl?url=' + encodeURIComponent(abs))
                        : '',
                    candidates: []
                });
            }).finally(() => {
                this.identifyBusy = false;
            });
        },
        enrichPastedName(){
            const name = (this.identifyPasteName || '').trim();
            if (!name) return;
            this.identifyBusy = true;
            axios.post(`/persons/${this.id}/identify-celebrity`, { name }, {
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            }).then((response) => {
                const data = response.data || {};
                const cands = Array.isArray(data.candidates) ? data.candidates : [];
                if (!cands.length) {
                    // Client-side split if wiki missed.
                    const parts = name.split(/\s+/);
                    this.applyCandidateToDraft({
                        first_name: parts[0] || name,
                        last_name: parts.slice(1).join(' '),
                        info: '',
                        link: '',
                        title: name
                    });
                    this.identifyMode = 'enriched';
                    this.identifyMessage = 'Имя разбито локально (Wikipedia не нашла статью). Проверьте и нажмите Apply.';
                    return;
                }
                this.identifyCandidates = cands;
                this.identifySelectedIdx = 0;
                this.applyCandidateToDraft(cands[0]);
                this.identifyMode = data.mode || 'enriched';
                this.identifyMessage = data.message || 'Данные из Wikipedia. Подтвердите Apply.';
                if (data.google_lens_url) {
                    this.identifyGoogleUrl = data.google_lens_url;
                }
            }).catch((error) => {
                console.log('enrich name error', error);
                alert('Не удалось обогатить имя через Wikipedia.');
            }).finally(() => {
                this.identifyBusy = false;
            });
        },
        applyIdentifyDraft(){
            if (!this.identifyDraft.first_name) {
                alert('Enter name');
                return;
            }
            this.identifyBusy = true;
            // Fill form fields first so user sees them even if save fails.
            this.model_person.first_name = this.identifyDraft.first_name;
            this.model_person.last_name = this.identifyDraft.last_name || '';
            if (this.identifyDraft.info) {
                this.model_person.info = this.identifyDraft.info;
            }
            if (this.identifyDraft.link) {
                this.model_person.link = this.identifyDraft.link;
            }
            axios.put(`/persons/${this.id}`, {
                first_name: this.model_person.first_name,
                last_name: this.model_person.last_name,
                email: this.model_person.email,
                info: this.model_person.info,
                link: this.model_person.link,
                category_id: this.category.id,
                uuid: this.model_person.uuid
            }).then((response) => {
                if (response.data) {
                    const faces = this.model_person.faces;
                    this.model_person = Object.assign({}, this.model_person, response.data);
                    if (!this.model_person.faces && faces) {
                        this.model_person.faces = faces;
                    }
                }
                this.closeIdentifyModal();
                alert('Saved');
            }).catch((error) => {
                console.log('apply identify error', error);
                alert('Поля заполнены в форме, но сохранение не удалось — нажмите SAVE.');
                this.closeIdentifyModal();
            }).finally(() => {
                this.identifyBusy = false;
            });
        },
        isSpoofSuspicion(flag){
            if (flag === true || flag === 1 || flag === '1') return true;
            if (Array.isArray(flag)) {
                return flag.some(function (x) {
                    return x === true || x === 1 || x === '1';
                });
            }
            return false;
        },
        movePerson(personId){
            this.personsIds = [personId];
            console.log
            bus.$emit('openpopup', {
                'title_form': 'Move person',
                'open': true,
                'type': 'moveperson',                
                'personsIds': this.personsIds
            });
        },
        mergePerson(pid){            
            bus.$emit('openpopup', {
                'title_form': 'Merge person',
                'open': true,
                'type': 'mergeperson',
                'person': this.model_person
            });            
        },
        deletePerson(id){                        
            const categoryUrl = `/categories/${this.category.id}`;            
            axios.delete('/persons/'+id).then((responce) => {                
                window.location.href = categoryUrl;
            }).catch((error) => {
                console.log('error delete person', error);
            });
        },
        updatePerson(){
            
            // if(this.images.length) this.sendImagesToSdk();
            
            if(this.listdelete.length){
                console.log('this.listdelete');
                this.deletePhotos();
            } 

            console.log('this.model_person.id: ', this.model_person.id);
            console.log('this.id: ', this.id);
            console.log('/persons/${this.id}: ', `/persons/${this.id}`);

            if(!this.model_person.first_name){
                alert('Enter name');
                return;
            }

            axios.put( `/persons/${this.id}`,
                {
                    first_name: this.model_person.first_name,
                    last_name: this.model_person.last_name,
                    email: this.model_person.email,
                    info: this.model_person.info,
                    link: this.model_person.link,
                    category_id: this.category.id,
                    uuid: this.model_person.uuid
                }
            ).then((responce)=>{
                console.log('update person', responce);
                alert('Saved');
            }).catch(function(){
                console.log('FAILURE!!');
            });
        },
        getPerson(){
            axios.get(`/persons/${this.id}`, {
                data: {},
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response) => {
                // handle success
                console.log('person get', response);
                this.model_person = response.data;
                this.warmAvatarCache();
            }).catch( (error) => {
                // handle error
                console.log(error);
            })
        },
        changeItem(){
            this.listdelete = [];
            console.log('this.listdelete: ', this.listdelete);
            this.model_person.faces.map((item, key) => {
                if(item.checked){
                    // Phase 4: delete by SDK images_hash (MySQL faces dropped).
                    this.listdelete.push(item.hash || item.id);
                }
            });
        },
        deletePhotos(){
            for(let i = 0; this.listdelete.length > i; i++){
                console.log(this.listdelete[i]);
                this.deletePhoto(this.listdelete[i]);
            }
            this.listdelete = [];
            this.model_person = {};
            this.getPerson();
        },
        deletePhoto(hashOrId){
            const uuid = this.model_person.uuid || this.model_person.person_uuid;
            const hash = hashOrId;
            axios.delete(`/faces/${encodeURIComponent(hash)}`, {
                params: { person_uuid: uuid, images_hash: hash },
            }).then((responce)=>{
                console.log('delete person', responce);
                this.getPerson();
            }).catch(function(){
                console.log('FAILURE!!');
            });            
        },
        uploadImage(e){
            const images = e.target.files; 
            this.images = images;           
            for (let i = 0; i < images.length; i++) {
                // this.sendImage(images[i], i);
                this.files.push(images[i]);
            }
            
            this.sendImagesToSdk();
        },
        sendImagesToDb(){
            let formData = new FormData();

            formData.append(`person_id`, this.model_person.id);

            console.log('this.model_person.id from send images to db: ', this.model_person.id);
            
            let totalfiles = this.goodImagesFiles.length;
            for (let index = 0; index < totalfiles; index++) {
                formData.append("images[]", this.goodImagesFiles[index]);
            }
            
            // formData.append(`hashes`, this.hashes);

            let totalhashes = this.hashes.length;
            for (let index = 0; index < totalhashes; index++) {
                formData.append("hashes[]", this.hashes[index]);
            }

            // console.log('this.hashes: ', this.hashes);

            axios.post( '/faces/addFacesToDb',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                }
            ).then((response)=>{
                
                console.log('response from send images to db: ', response.data);
                

                let addResultMessage = '';
                if(!this.badImages.length) {
                    addResultMessage = 'All faces added successfully.';
                }

                let add_person_report = {
                    'badImages': this.badImages,
                    'spoofWarnings': this.spoofWarnings,
                    'result': addResultMessage
                };

                bus.$emit('openpopup', {
                    'open': true,
                    'type': 'addpersonreport',                        
                    'title_form': 'Add faces result',
                    'add_person_report': add_person_report
                });

                this.getPerson();
            
            }).catch(function(error){
                console.log('FAILURE!!');
                console.log(error);                
            });


        },
        // sendImagesToSdk(file, id){
        sendImagesToSdk(){
            
            let formData = new FormData();                        
                        
            if(this.image_turn_id){
                formData.append(`image_turn_id`, this.image_turn_id);
            } else {
                let totalfiles = this.images.length;
                for (let index = 0; index < totalfiles; index++) {
                    formData.append("faces[]", this.images[index]);
                }
                formData.append("person_uuid", this.model_person.uuid);
            }
            
            axios.post( '/faces/sendFacesTosdk',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                }
            ).then((response)=>{               
                // this.getPerson();
                console.log('Result send images to sdk: ', response.data);

                this.sendFacesToSDKnum++;
                console.log('this.sendFacesToSDKnum: ', this.sendFacesToSDKnum);

                if( response.data.image_turn_id ){
                    this.image_turn_id = response.data.image_turn_id;
                    console.log('this.image_turn_id: ', this.image_turn_id);
                }

                // API v2 may return person_uuid on enqueue; wait for poll report.
                const facesDone = !!(response.data.good_image || response.data.bad_image);

                if( 
                    !facesDone && 
                    this.sendFacesToSDKnum < this.sendFacesSDKlimit
                ){
                    setTimeout(()=>{this.sendImagesToSdk();}, 2000);
                }

                 if( facesDone && response.data.person_uuid ){
                    
                    console.log('Info from sdk: ', response.data);


                    const bad = (response.data.bad_image && response.data.bad_image.description) || [];
                    bad.forEach((description, curIndex) => {
                        let fileIndex = response.data.bad_image.index[curIndex],
                            fileName = (this.files[fileIndex] && this.files[fileIndex].name) || fileIndex,
                            curMessage = `Image ${fileName} not added, ${description}`;
                        this.badImages.push(curMessage);
                    });

                    if (this.isSpoofSuspicion(response.data.spoofing_atack)) {
                        this.spoofWarnings.push('Подозрение на спуф (изображение может быть подделкой).');
                    }

                    const goodHashes = (response.data.good_image && response.data.good_image.image_hash) || [];
                    goodHashes.forEach((hash, curIndex) => {
                        this.hashes.push(hash);
                        let fileIndex = response.data.good_image.index[curIndex],
                            curFile = this.files[fileIndex];
                        this.goodImagesFiles.push(curFile);
                    });
                    
                    
                    
                    this.sendImagesToDb();
                }

                if( this.sendFacesSDKnum >= this.sendFacesSDKlimit )
                    console.log('Num of send limit is over.');
            

            }).catch(function(error){
                console.log('FAILURE!!');
                console.log(error);                
            });
        },
        sendImage(file, id){
            let formData = new FormData();
            formData.append(`person_id`, this.model_person.id);
            formData.append(`file`, file);
            axios.post( '/faces',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                }
            ).then((responce)=>{               
                this.getPerson();
            }).catch(function(){
                console.log('FAILURE!!');
            });
        }
    },
    mounted(){
        this.getPerson();
        bus.$on('addcategory', (data) => {
            // this.categories.push(data);
            let token = document.head.querySelector('meta[name="csrf-token"]');
            window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
            axios.post('/categories', data)
            .then(function (response) {
                // handle success
                console.log('handle success', response.data);
                // if(response.data.name){
                    this.data.push(response.data);
                    // console.log(this.data)
                // }
                // this.getCategories();
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
        });
    },
    computed: {
        dataItem(){
            this.data.map((item) => {
                item.checked = false;
            });
            return this.data;
        },
        personsFaces(){            
            const faces = this.model_person && this.model_person.faces;
            if (!Array.isArray(faces) || !faces.length) {
                // Server should populate faces; keep a last-resort avatar tile.
                const uuid = (this.model_person && (this.model_person.uuid || this.model_person.person_uuid)) || '';
                if (!uuid) return [];
                return [{
                    id: 1,
                    hash: 'avatar',
                    checked: false,
                    image: { fullpath: '/person-avatar/' + uuid }
                }];
            }
            return faces;
        },
        // Static /images/* paths only — Google cannot fetch auth-gated /person-avatar.
        bestPublicImagePath(){
            const faces = this.personsFaces || [];
            for (let i = 0; i < faces.length; i++) {
                const img = faces[i] && faces[i].image;
                const full = img && (img.fullpath || (img.path ? ('/images/' + img.path) : ''));
                if (full && full.indexOf('/images/') === 0) {
                    return full;
                }
            }
            const uuid = this.personUuid();
            if (uuid) {
                return '/images/avatar_cache/' + uuid + '.jpg';
            }
            return '';
        },
        canIdentify(){
            return !!(this.personUuid() || this.bestPublicImagePath);
        },
        identifyModalTitle(){
            if (this.identifyMode === 'auto') return 'Подтвердите данные знаменитости';
            if (this.identifyMode === 'enriched') return 'Подтвердите данные (Wikipedia)';
            return 'Распознать знаменитость';
        }
    },
    components: {
        Dotscontrol,
        iconsort,
    }
}
</script>

<style scoped>
.celebrity-identify-modal {
    position: fixed;
    inset: 0;
    z-index: 1050;
    display: flex;
    align-items: center;
    justify-content: center;
}
.celebrity-identify-modal__bg {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
}
.celebrity-identify-modal__body {
    position: relative;
    z-index: 1;
    width: min(560px, 92vw);
    max-height: 90vh;
    overflow: auto;
    padding: 1.5rem;
}
</style>
